import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import {
  ReceivedDocument,
  DOCUMENT_TYPE_LABELS,
} from "../../models/received-document";

interface ReceivedDocumentDeleteModalProps {
  show: boolean;
  document?: ReceivedDocument;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const ReceivedDocumentDeleteModal: React.FC<
  ReceivedDocumentDeleteModalProps
> = ({ show, document, onCancel, onSuccess }) => {
  const [submitting, setSubmitting] = useState(false);

  const documentTypeLabel = document?.documentType
    ? DOCUMENT_TYPE_LABELS[document.documentType] ?? document.documentType
    : "";

  const message = document
    ? `¿Está seguro de que quiere eliminar el documento "${documentTypeLabel} ${document.documentNumber}" de ${document.supplierSocialName}?`
    : "";

  const onDeleteClick = async () => {
    if (document !== undefined) {
      setSubmitting(true);
      const status = await deleteItem(
        `/received_documents/${document.id}/`,
        document,
      );

      if (status.status !== SUCCESS) {
        let msg = "Ha ocurrido un error!!";
        if (status.detail !== undefined) {
          msg = status.detail;
        }
        errorAlert(msg);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default ReceivedDocumentDeleteModal;
